import { jsonp } from '../../../base/base';

let cbNum = 0;
const bottomSlidesFn = async (config, apiUrl) => {
    cbNum += 1;

    // 新接口nine,旧的接口api.3g(即将废弃)
    if (apiUrl.includes('nine')) {
        const result = await jsonp(`//${apiUrl}.ifeng.com/relateshare?${config}`, {
            jsonpCallback: `wxshareCallback0${cbNum}`,
            cache: false,
        });

        if (result && result.code === 0 && result.data && result.data.length > 0) {
            return result.data.map((item) => {
                return {
                    ...item,
                    abTest: result?.abTest || '',
                };
            });
        } else {
            return [];
        }
    } else {
        return await jsonp(`//api.3g.ifeng.com/client_share_bottom_number?${config}`, {
            jsonpCallback: `wxshareCallback0${cbNum}`,
            cache: false,
        });
    }
};

export { bottomSlidesFn };
